import { Accordion, AccordionDetails, AccordionSummary, Icon, theme } from '@ketch-com/deck'
import React from 'react'

interface AssessmentConditionalQuestionsAccordionProps {
  key: string
  children: React.ReactNode
}

export const AssessmentConditionalQuestionsAccordion: React.FC<AssessmentConditionalQuestionsAccordionProps> = ({
  key,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(true)
  const handleToggle = () => {
    setIsOpen(prev => !prev)
  }
  return (
    <Accordion
      expanded={isOpen}
      key={key}
      sx={{
        borderInline: `1px solid ${theme.palette.Infographics.BlueE.Primary}`,
        borderBlockEnd: `1px solid ${theme.palette.Infographics.BlueE.Primary}`,
      }}
    >
      <AccordionSummary
        onClick={handleToggle}
        size="small"
        sx={{
          backgroundColor: theme.palette.Infographics.BlueE.Primary,
        }}
        hideIcon
      >
        <Icon name="FArrowFork" iconColor={theme.palette.Common.Container} />
      </AccordionSummary>
      <AccordionDetails size="xlarge">{children}</AccordionDetails>
    </Accordion>
  )
}
